import React from "react";
import { useSelector } from "react-redux";
import GameSet from "./GameSet";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import SimpleBox from "../layout/container/SimpleBox";

const NextGames = () => {
    const nextGames = useSelector(state => state.seasons.nextGames);
    return <GameSet games={nextGames} direction={1} title="Próximos Jogos" />
}

export default NextGames;
